import { render, staticRenderFns } from "./TradingOrdersFilters.vue?vue&type=template&id=18a08db9&scoped=true&"
import script from "./TradingOrdersFilters.vue?vue&type=script&lang=js&"
export * from "./TradingOrdersFilters.vue?vue&type=script&lang=js&"
import style0 from "./TradingOrdersFilters.vue?vue&type=style&index=0&id=18a08db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a08db9",
  null
  
)

export default component.exports